import { useCallback, useRef } from 'react'
import type { Dispatch, SetStateAction } from 'react'

// InputAudio appends a transcript to the text with a state setter (`setQuestion(prev => ...)`). The owner of a text
// that only has `updateText(value)` gets such a setter from this hook, which resolves the update against the text of
// the latest render.
const useSetQuestion = (text: string, updateText: (value: string) => void): Dispatch<SetStateAction<string>> => {
    const textRef = useRef(text)
    textRef.current = text

    return useCallback(
        (next) => updateText(typeof next === 'function' ? next(textRef.current) : next),
        [updateText]
    )
}

export default useSetQuestion
